import React from 'react';
import moment from 'moment';

import config from './../../config';
import Locale from './../../Locale';
import Member from './../../Member';
import Validation from './../../Validation';
import ApplyAPI from './../../api/ApplyAPI';
import AgentAPI from './../../api/AgentAPI';
import InsuranceProductScreen from './../InsuranceProductScreen';

export default class AHIScreen extends InsuranceProductScreen {
  constructor(props) {
    super(props, 'AHI');

    this.premiumPlanOptions = [
      {value: 'I', label: Locale.text.individualPlan},
      {value: 'F', label: Locale.text.familyPlan},
    ];

    const {insuranceProduct} = this.state;

    if (!insuranceProduct.pl) {
      insuranceProduct.pl = 'AHI1';
      insuranceProduct.ahi = {premiumPlan: 'I'};
      insuranceProduct.members = [{relationship: 'insured'}];
    }
  }

  updateAHI(data) {
    this.updateInsuranceProduct('ahi', data);
  }

  updateMembers(index, data) {
    const {members} = this.state.insuranceProduct;

    if (members[index]) {
      Object.assign(members[index], data);
    }
    else {
      members[index] = data;
    }

    this.setState({insuranceProduct: this.state.insuranceProduct});
  }

  getPremiumPlanLabel() {
    const {ahi} = this.state.insuranceProduct;

    switch (ahi.premiumPlan) {
      case 'I': return Locale.text.individualPlan;
      case 'F': return Locale.text.familyPlan;
    }
  }

  handleLeavePage(e) {
    const confirmationMessage = 'Some message';
    e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
    return confirmationMessage;              // Gecko, WebKit, Chrome <34
  }
  
  componentDidMount() {
   // window.addEventListener('beforeunload', this.handleLeavePage);

  }
  componentWillUnmount() {
    //window.removeEventListener("beforeunload", this.handleLeavePage);
 }

  componentDidUpdate() {
    const {ahi, members} = this.state.insuranceProduct;

    if (ahi.premiumPlan == 'I' && members.length > 1) {
      while (members.length > 1) {
        members.pop();
      }

      this.refresh();
    }
  }

  buyAgain() {
    if (super.buyAgain()) {
      const {insuranceProduct} = this.state;
      const {dataFormat} = config.date;

      insuranceProduct.ahi = this.getParam('ahi');
      insuranceProduct.members = this.getParam('members');

      insuranceProduct.members.forEach((member) => {
        member.dateOfBirth = moment(member.dateOfBirth).format(dataFormat);
        member.relationship = member.relationship.relationshipKey;
      });
    }
  }

  getQuote(nextScreen) {
    this.setState({waiting: true}, () => {
      const {pn, pl, agent, policy, policyHolder,
        ahi, payment, members} = this.state.insuranceProduct;

      const {trimAndRemoveEmptyStrings, getValidator} = Validation;

      [agent, policy, policyHolder, ahi, payment].forEach((data) => {
        trimAndRemoveEmptyStrings(data);
      });

      const messages = {};

      const discountValidation = new Validation(
        {
          businessEmail: policy.businessEmail,
          promotionCode: payment.promotionCode,
        },
        {
          businessEmail: getValidator('text'),
          promotionCode: getValidator('text'),
        }
      );

      messages.discount = discountValidation.validate();

      if (nextScreen == 'ahi4') {
        const agentValidation = new Validation(
          agent,
          {mobile: getValidator('number')}
        );

        messages.agent = agentValidation.validate();

        const policyValidation = new Validation(
          policy,
          {
            effectiveDateStart: getValidator('text', true),
            specialRequest: getValidator('text'),
          }
        );

        messages.policy = policyValidation.validate();

        const policyHolderValidation = new Validation(
          policyHolder,
          {
            firstName: getValidator('text', true),
            lastName: getValidator('text', true),
            mobile: getValidator('number', true),
            email: getValidator('email', true),
            address1: getValidator('text'),
            documentType: getValidator('text', true),
            documentNo: getValidator('HKID', true),
            dateOfBirth: getValidator('text', true),
          }
        );

        messages.policyHolder = policyHolderValidation.validate();

        const membersMessages = [];

        members.forEach((member, index) => {
          const memberValidation = new Validation(
            member,
            {
              firstName: getValidator('text', true),
              lastName: getValidator('text', true),
              documentType: getValidator('text', true),
              documentNo: getValidator('HKID', true),
              dateOfBirth: getValidator('text', true),
              relationship: getValidator('text', true),
            }
          );

          const memberMessages = memberValidation.validate();

          if (memberMessages) {
            membersMessages[index] = memberMessages;
          }
        });

        if (JSON.stringify(membersMessages) != '[]') {
          messages.members = membersMessages;
        }
      }

      const invalid = JSON.stringify(messages) != '{}';

      if (invalid) {
        this.alert(
          Locale.text.alert,
          Locale.text.check,
          [{text: Locale.text.ok, onPress: () => this.dismissAlert()}]
        );

        this.setState({messages, waiting: false});
      }
      else if (
        nextScreen == 'ahi4' && ahi.premiumPlan == 'F' && members.length == 1
      ) {
        this.setState({waiting: false}, () => {
          this.alert(
            Locale.text.check,
            Locale.text.youHaveOneInsuredOnly,
            [
              {
                text: Locale.text.ok,
                onPress: () => {this.updateAHI({premiumPlan: 'I'}); this.dismissAlert()},
              },
              {
                text: Locale.text.cntinueInputting,
                onPress: () => {this.setState({waiting: false}); this.dismissAlert()},
              },
            ],
            {cancelable: false},
          );
        });
      }
      else {
        this.readPremium({
          'pn': pn,
          'pl': pl,
          'member.id': Member.getMemberId(),
          'policy.effectiveDateStart': policy.effectiveDateStart,
          'policy.businessEmail': policy.businessEmail,
          'ahi.premiumPlan': ahi.premiumPlan,
          'payment.promotionCode': payment.promotionCode,
        })
        .then(({premium, levy}) => {
          this.push(nextScreen, {premium, levy});
        });
      }
    });
  }

  confirm() {
    this.setState({waiting: true}, () => {
      const {pn, pl, agent, policy, policyHolder,
        ahi, members, payment} = this.state.insuranceProduct;

      const {getValidator, getProductConfirmationValidator} = Validation;

      const confirmationValidation = new Validation(
        policy,
        {
          disclaimerAndPIC: getProductConfirmationValidator(),
          declaration: getProductConfirmationValidator(),
          allowPrivacyPromote: getValidator('text', true),
          commissionsDisclosures:
            (this.state.agent || this.state.broker || payment.promotionCode) &&
              getProductConfirmationValidator(),
        }
      );

      const messages = confirmationValidation.validate();

      if (messages) {
        this.alert(
          Locale.text.alert,
          Locale.text.check,
          [{text: Locale.text.ok, onPress: () => this.dismissAlert()}]
        );

        this.setState({messages, waiting: false});
      }
      else {
        this.apply(
          Locale.text.ahiInsurance,
          this.state.broker ? AgentAPI.ahi : ApplyAPI.ahi,
          {
            'pn': pn,
            'pl': pl,
            'member.id': Member.getMemberId(),
            'agent.mobile': agent.mobile,
            'policy.effectiveDateStart': policy.effectiveDateStart,
            'policy.effectiveDateEnd': policy.effectiveDateEnd,
            'policy.allowPrivacyPromote3P': policy.allowPrivacyPromote3P,
            'policy.allowPrivacyPromote': policy.allowPrivacyPromote,
            'policy.businessEmail': policy.businessEmail,
            'policy.specialRequest': policy.specialRequest,
            'policyHolder.salutation': policyHolder.salutation,
            'policyHolder.firstName': policyHolder.firstName,
            'policyHolder.lastName': policyHolder.lastName,
            'policyHolder.mobile': policyHolder.mobile,
            'policyHolder.email': policyHolder.email,
            'policyHolder.address1': policyHolder.address1,
            'policyHolder.documentType': policyHolder.documentType,
            'policyHolder.documentNo': policyHolder.documentNo,
            'policyHolder.dateOfBirth': policyHolder.dateOfBirth,
            'ahi.premiumPlan': ahi.premiumPlan,
            'members': members,
            'payment.ecash': payment.ecash,
            'payment.promotionCode': payment.promotionCode,
            'rawRequest': JSON.stringify(this.state.insuranceProduct),
          }
        );
      }
    });
  }
}
